export const Compound = () => (
  <svg
    width="59"
    height="59"
    viewBox="0 0 59 59"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-11%"
        y="-7.6%"
        width="122.1%"
        height="130.5%"
        filterUnits="objectBoundingBox"
        id="vtrelel9ga"
      >
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" in="shadowBlurOuter1" />
      </filter>
      <path
        d="m46.045 32.91-5.784-3.521v-6.811l5.828-4.197a.681.681 0 0 0-.792-1.107l-5.735 4.13-2.211-1.433-3.881-2.514v-7.173a.68.68 0 1 0-1.358 0v7.173L26 21.417l-6.112-3.96v-7.173a.68.68 0 1 0-1.358 0v7.173l-6.123 3.968-5.747-3.498a.68.68 0 0 0-.705 1.163l5.785 3.521v6.811L5.91 33.62a.682.682 0 0 0-.156.95.678.678 0 0 0 .948.157l5.735-4.13 2.211 1.433 3.881 2.514v7.173a.68.68 0 1 0 1.358 0v-7.173L26 30.583l6.112 3.96v7.173a.68.68 0 1 0 1.358 0v-7.173l6.123-3.968 5.748 3.498a.68.68 0 0 0 .705-1.163"
        id="rymruxwogb"
      />
    </defs>
    <g transform="rotate(45 26.086 33.036)" fillRule="nonzero" fill="none">
      <use fill="#000" filter="url(#vtrelel9ga)" xlinkHref="#rymruxwogb" />
      <use fill="#FFF" xlinkHref="#rymruxwogb" />
    </g>
  </svg>
);
